export default "__VITE_ASSET__ac28bb7e__"